import { Menu } from "@mui/material";

export default function MenuElevationClass({ children, ...props }) {
    return (
        <Menu
            {...props}
            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    '& .MuiList-root': {
                        display: 'flex', 
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                    }
                },
            }}>
            {children}
        </Menu>
    )
}